define('viewmodels/Wizard',['knockout', 'underscore'], function (ko, _) {

    function Wizard(publishStepChanged, params) {

        _.extend(this, params);

        this.stepNumber = ko.observable(1);

        this.stepNumber.subscribe(publishStepChanged);

        this.step = ko.pureComputed(function() {
            return this.steps[this.stepNumber() - 1];
        }.bind(this));

        this.furthestStepNumber = ko.observable(1);

        this.progressPercentage = ko.pureComputed(function() {
            return ((this.furthestStepNumber() - 1) / this.steps.length);
        }.bind(this));

        this.isSummary = ko.pureComputed(function() {
            return !this.step();
        }.bind(this));

        this.returnToIncompleteStep = function() {

            var errorStepIndex = _.findIndex(this.steps, function(step) {
                return !step.field.isGood();
            });

            if (errorStepIndex >= 0) {
                this.stepNumber(errorStepIndex + 1);
            }

        };

    }

    Wizard.prototype.proceed = function() {

        var finalStep = this.hasSummary ? this.steps.length + 1 : this.steps.length;

        if (this.stepNumber() >= finalStep) {
            return this.onComplete();
        }

        if (this.furthestStepNumber() > this.stepNumber()) {
            this.stepNumber(this.furthestStepNumber());
            this.returnToIncompleteStep();
        } else {
            this.stepNumber.increment();
            this.furthestStepNumber.increment();
        }

    };

    Wizard.prototype.proceeds = function() {
        return function() {
            return this.proceed();
        }.bind(this);
    };

    Wizard.prototype.returnsToStep = function(stepNumber) {
        return function() {
            this.stepNumber(stepNumber);
        }.bind(this);
    };

    Wizard.prototype.setsValueAndProceeds = function(value) {
        return function() {
            this.step().field.value(value);
            this.proceed();
        }.bind(this);
    };

    return Wizard;
});

